import React from "react"
import DMSTable from "./DmsTable"
import DmsTableHeader from "./table/DmsTableHeader"

const DMSHomePage = () => {
  return (
    <DmsTableHeader>
      <DMSTable />
    </DmsTableHeader>
  )
}

export default DMSHomePage
